//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    "initData", //初始化数据
    "searchType", //类型
    "approShow", //近似 隐藏显示
    "applicantShow", //申请人 隐藏显示
    "agencyShow", //代理机构 隐藏显示
    "historys",
    "resetKey",
    "menuForm",
    "pageName",
    'tabSearchType',
    'menuAlike',
    "edition" // 是简易版本 还是高级版本
  ],
  data() {
    return {
      showBtn: false,
      searchMenus: this.tools.searchMenus,
      isTips: false,
      popoverVisible: false,
      popoverVisible6: false
    };
  },
  mounted() {
    console.log(this.initData)
    if (this.pageName === 'businessSearch') {
      this.searchMenus = [
        { name: "商标名", value: "2" },
        { name: "商标号", value: "3" },
        { name: "申请人", value: "4" },
        { name: "代理机构", value: "5" }
      ]
    //} else if (this.pageName === "notice" || this.edition === "simple") {
    } else if (this.pageName === "notice" || this.$store.state.user.uc_memberType != 3) {
      this.searchMenus = this.tools.searchMenus.filter(
        obj => obj.name !== "超凡盲区"
      );
    }
    this.getShowBtn();
    window.addEventListener("resize", () => this.getShowBtn(), false);
    this.goMenu(parseInt(this.searchType) - 1);
  },
  watch: {
    edition () {
      if (this.pageName === "notice" || this.$store.state.user.uc_memberType != 3) {
        this.searchMenus = this.tools.searchMenus.filter(
          obj => obj.name !== "超凡盲区"
        );
      } else {
        this.searchMenus = this.tools.searchMenus;
      }
      let _query = this.$route.query;
      let _searchType = _query && _query.type ? query._query : "1";
      this.$emit('update:searchType', _searchType)
      this.getShowBtn();
    }
  },
  methods: {
    // 切换查询模式 -- 简易版 高级版
    /*tapPattern(){
      let _tabSearchType = this.tabSearchType === 1 ? 2 : 1
      this.$axios
        .post("/api/trademark/switchSearchType", { tabSearchType: _tabSearchType })
        .then(res => {
          // this.tabSearchType = _tabSearchType;
          this.$emit('update:tabSearchType', _tabSearchType)
          let _edition = _tabSearchType == 1 ? 'highRank' : 'simple';
          this.$emit('update:edition', _edition)
          this.$emit('tapPattern')
        });
    },*/
    simpleMenuSubmit(){
      this.popoverVisible6 = false;
      this.searchSubmit();
    },
    getShowBtn() {
      let dom = document.getElementById("typeScrollId");
      if (dom) {
        this.showBtn =
          this.pageName === "notice"
            ? dom.offsetWidth < 440
            : dom.offsetWidth < 500;
      }
    },
    onKeyPress(event) {
      event = event || window.event;
      if (event.keyCode == 13) {
        event.returnValue = false;
        event.preventDefault();
        this.searchSubmit();
      }
    },
    //触发查询
    searchSubmit() {
      this.$emit("searchSubmit");
    },
    // 点击历史记录
    historyGo(item) {
      this.$emit("historyGo", item);
    },
    //面板显示隐藏 更多 返回
    SHMenuPlan(type, isShow) {
      this.$emit("SHMenuPlan", type, isShow);
    },
    //近似 多选按钮点击
    checkApproximateMenu(item, i) {
      this.$emit("checkApproximateMenu", item, i);
    },
    //近似 多选 全选 反选
    approximateMenuReset(type) {
      this.$emit("approximateMenuReset", type);
    },
    //点击菜单自动滚动到中间
    clickMenus(index, item) {
      this.$emit("clickMenuValue", item.value);
      this.goMenu(index);
    },
    goMenu(index) {
      this.$nextTick(() => {
        const content = this.$refs.tabOverflow; // 发生滑动的元素
        const activeItem = content.children[index]; // 当前选中的元素
        if (!activeItem) return false;
        const contentWidth = content.offsetWidth; // 发生滑动元素的宽
        const activeItemWidth = activeItem.offsetWidth; // 当前元素的宽
        const activeItemLeft = activeItem.offsetLeft; // 当前元素的到他父盒子左侧的距离
        const offset = activeItemLeft - (contentWidth - activeItemWidth) / 2; // 需要移动的位置
        console.log(activeItemLeft)
        content.scrollTo(offset);
      });
    },
    //菜单左右箭头点击
    clickTopImg(type) {
      let num = 7;
      const timeTop = setInterval(() => {
        const content = this.$refs.tabOverflow;
        const scrollLeft = content.scrollLeft;
        content.scroll(type ? scrollLeft + 10 : scrollLeft - 10, 0);
        num--;
        if (num <= 0) {
          clearInterval(timeTop);
        }
      }, 15);
    },
    focusIpt(val, str) {
      let _selectAnd = document.getElementById("selectAnd").offsetWidth;
      if (_selectAnd < 458) {
        val ? (this.isTips = false) : (this.isTips = true);
        if (str === "blur") {
          this.isTips = false;
        }
      } else {
        this.isTips = false;
      }
    },
    filterConfirmAlike(param){
      // param typeSelect,classSelect
      this.popoverVisible = false
      this.$emit('filterConfirmAlike', param)
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getShowBtn(), false);
  },

};
